import StatusChip from "./StatusChip";

const HumReadyChip = ({ connected }) => {
  const label = connected ? "Yes" : "No";
  const level = connected ? "positive" : "negative";
  return <StatusChip label={label} level={level} />;
};

export default HumReadyChip;
